import { create } from "zustand";

import axios from "../helper/axios";



const useJobApplicationStore = create((set) => ({
    linkedApplication:null,
    linkedApplicationError:"",
    linkedProfileResume:null,
    linkedJd:null,
            
    getLinkedApplicationByJD: async (qhoid,jdid,qhuid,rid) => {
        let date = new Date();
        let timestamp = date.getTime();
        try {
           const response = await axios.get(`/getLinkedApplication/${qhoid}/${qhuid}/jds/${jdid}/${rid}/${timestamp}`);
            console.log("Linked Data",response.data.name);
            console.log(response.data.status);
            console.log(response.data.data);
            console.log(response.data.jd);

            set({ linkedApplication: response?.data.data });
            set({ linkedJd: response?.data.jd });  
            set({ linkedApplicationError: "" });
        } catch (err) {
            console.log("Linked Data Error",err);
            set({ linkedApplication: null });
            set({ linkedJd: err.response.data.jd });
            set({ linkedApplicationError: err.response.data.error });
            console.log(err.response.data.jd);
            console.error(err);
        }
    },

    updateProfileInLinkedApplication: async (qhoid,qhuid,body) => {
        try {
            console.log(body);
            const response = await axios.post(
                `/linkedcandidateprofile/${qhoid}/${qhuid}/jds/${body.jdID}/${body.resumeID}`,
                body.jasonValues
            );
            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },
    resetSelectedApplication: async (jdid,id) => {
        set({ linkedApplication: null });
    },  
    getLinkedProfileResumeDetails: async (qhoid,qhuid,jdid,id) => {
        try {
           const response = await axios.get(`/getcandidateprofile/${qhoid}/${qhuid}/jds/${jdid}/${id}`);
            console.log(response.data);
            set({ linkedProfileResume: response?.data });
        } catch (err) {
            console.error(err);
        }
    }, 
                      
}));



export default useJobApplicationStore;
